export default __webpack_public_path__ + "1d64619.png";